<template>
  <svg width="27" height="14" fill="var(--sf-base-icon-secondary)" viewBox="0 0 27 14" xmlns="http://www.w3.org/2000/svg">
    <rect width="22" height="14" rx="4" />
    <path d="M24 4V10C25.6569 10 27 8.65685 27 7C27 5.34315 25.6569 4 24 4Z" />
  </svg>
</template>
